import {
  getProjectConfig,
  getDidProjectConfig,
  savePageConfig,
  saveProjectConfig,
  getUserConfig,
  getModulesConfig
} from '../../api/usermanage'

const opts = {
  menuPosition: 'top', // left top
  menuStyle: 'all', // icon text
  menuColor: '#2a3140', //
  menuTextColor: '#fff',
  menuActiveColor: '#3e495f',
  subMenuColor: '#',
  fullScreen: 'full' // full head background
}
let callbackFun = null
export default {
  state: {
    dialogMenuVisible: false,
    componentOpts: {
      title: '配置'
    },
    componentName: null,
    globalConfig: {
      logoImage: '/static/logo_black.png',
      backgroundImage: ''
    },
    pageConfig: {

    },
    // 项目配置
    menuConfig: null,
    componentAction: null,
    componentData: null,
    isVisable: false // 编辑模式
  },
  mutations: {
    // 编辑模式
    SET_VISIBLE: (state, val = false) => {
      state.isVisable = val
    },
    // 全局配置
    SET_GLOBALCONFIG: (state, val) => {
      state.globalConfig = val
    },
    // 菜单配置
    SET_MENUCONFIG: (state, val) => {
      state.menuConfig = val || { ...state.menuConfig }
    },
    // 页面配置
    SET_PAGECONFIG: (state, { page, val }) => {
      state.pageConfig[page] = val
    },
    // 弹框组件扩展属性
    SET_COMPONENTOPTS: (state, val) => {
      state.componentOpts = val
    },
    // 弹框组件显示隐藏
    IS_SHOW_COMPONENT: (state, val = false) => {
      state.dialogMenuVisible = val
    },
    // 传入组件属性
    SETCOMPONENT: (state, { template = null, action = null, data = null }) => {
      state.componentName = template
      state.componentData = data
      state.componentAction = action
    }
  },
  actions: {
    /**
     * 设置全局配置
     * @param {*} data
     * @reture
     */
    SetGlobaConfig({ dispatch, state, commit }, data = {}) {
      let { customJson = { ...opts } } = data
      if (typeof customJson === 'string') customJson = JSON.parse(customJson)
      return new Promise((resolve, reject) => {
        commit('SET_MENUCONFIG', customJson)
        commit('SET_GLOBALCONFIG', data)
        resolve()
      })
    },
    /**
     * 设置组件
     * @param {*} template 模板
     * @param {*} action 保存触发action
     * @param {*} data 模板数据
     * @reture
     */
    SetComponent({ commit, state }, { template, action, data, options }) {
      options && commit('SET_COMPONENTOPTS', options)
      return new Promise((resolve, reject) => {
        commit('IS_SHOW_COMPONENT', true)
        commit('SETCOMPONENT', { template, action, data })
        callbackFun = resolve
      })
    },
    /**
     * 关闭组件
     * @param {*} data
     * @reture
     */
    ColseConfig({ dispatch, state, commit }, oldData) {
      callbackFun = null
      return new Promise((resolve, reject) => {
        commit('IS_SHOW_COMPONENT', false)
        commit('SETCOMPONENT', {})
        resolve()
      })
    },
    /**
     * 弹框组件确定回调
     * @param {*} data
     * @reture
     */
    SaveConfig({ dispatch, state, commit }, data) {
      if (state.componentAction) {
        return dispatch(state.componentAction, data).then(() => {
          callbackFun(data)
        })
      } else {
        return new Promise((resolve, reject) => {
          callbackFun(data)
          resolve(data)
        })
      }
    },
    /**
     * 保存全局配置
     * @param {*} data
     * @reture
     */
    SaveMenuConfigAdmin({ commit }, data) {
      return new Promise((resolve, reject) => {
        saveProjectConfig(data).then(res => {
          resolve(res.data)
        })
      })
    },
    // 根据部门ID,页面类型
    GetModulesConfig({
      state,
      commit
    }, data) {
      return new Promise(resolve => {
        let pageConfig = state.pageConfig[data.pageType]
        if (!state.isVisable && state.pageConfig[data.pageType]) {
          resolve(pageConfig)
          return
        }
        getModulesConfig(data).then(res => {
          if (res.data) {
            let { content = [] } = res.data
            if (typeof content === 'string') content = JSON.parse(res.data.content)
            res.data.content = content
          } else {
            res.data = {}
          }
          commit('SET_PAGECONFIG', { page: data.pageType, val: res.data })
          resolve(res.data)
        })
      })
    },
    // 根据简拼获取配置
    GetProjectConfig({
      commit,
      state
    }, data) {
      return new Promise(resolve => {
        getProjectConfig(data).then(res => {
          if (res.data) {
            let { customJson = { ...opts } } = res.data
            if (typeof customJson === 'string') customJson = JSON.parse(res.data.customJson)
            res.data.customJson = customJson
          } else {
            res.data = {
              projectName: '',
              simpleName: '',
              logoImage: '',
              backgroundImage: '',
              projectFlag: 1,
              serviceType: 1,
              buyType: 1,
              expiredTime: '2099-12-12',
              customJson: { ...opts }
            }
          }
          resolve(res.data)
        })
      })
    },
    // 根据部门id获取配置
    GetDidProjectConfig({
      commit
    }, data) {
      return new Promise(resolve => {
        getDidProjectConfig(data).then(res => {
          resolve(res.data)
        })
      })
    },
    // 获取用户项目配置
    getUserConfig({
      commit
    }, data) {
      return new Promise(resolve => {
        getUserConfig(data).then(res => {
          resolve(res.data)
        })
      })
    },
    // 保存自定义页面
    SavePageConfig({
      commit
    }, data) {
      return new Promise(resolve => {
        savePageConfig(data).then(res => {
          resolve(res.data)
        })
      })
    }
  }
}
